// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"128":"f464308a","788":"23790a66"}[chunkId] + ".chunk.css";
};